export const RENDER_EVENT = 'd24:render-request';

export function requestRender() {
  window.dispatchEvent(new CustomEvent(RENDER_EVENT));
}
